import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
} from '@mui/material';
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';

import Row from './CollapsibleTableRow';
import RowSkeleton from './CollapsibleRowLoading';

import styled from '@emotion/styled';
import { useState } from 'react';

const TableRowStyle = styled(TableRow)`
  .last-tr {
    border-right: none;
  }
`;

const TableCellRow = styled(TableCell)`
  border-right: 1px solid #a3a3a3;
  padding: 0 1em;
`;

const TableHeader = styled(TableCell)`
  background-color: #d5e7f7;
  border-right: 1px solid #a3a3a3;
  padding: 0 1em;
`;

const iterate5Times = [...Array(5).keys()];

export default function CollapsibleTable({
  productList,
  isFirstLoad,
  isProductsLoading,
  searchProducts,
  previousSearchValues,
}) {
  const [open, setOpen] = useState(true);

  if (isFirstLoad || !previousSearchValues.route) {
    return (
      <>
        <TableContainer component={Paper}>
          <Table aria-label="collapsible table" stickyHeader>
            <TableHead>
              <TableRowStyle>
                <TableHeader>
                  {productList.length > 0 ? (
                    <IconButton
                      aria-label="expand row"
                      size="small"
                      onClick={() => setOpen(!open)}
                    >
                      {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                    </IconButton>
                  ) : (
                    <></>
                  )}
                </TableHeader>
                <TableHeader>Order Number</TableHeader>
                <TableHeader>Driver</TableHeader>
                <TableHeader>Customer</TableHeader>
                <TableHeader className="last-tr">Dispatch</TableHeader>
              </TableRowStyle>
            </TableHead>
            <TableBody>
              <TableRowStyle sx={{ '& > *': { borderBottom: 'unset' } }}>
                <TableCellRow colSpan={4} align="center">
                  {'Please enter a route and delivery date to see orders.'}
                </TableCellRow>
              </TableRowStyle>
            </TableBody>
          </Table>
        </TableContainer>
      </>
    );
  }

  if (productList.length === 0) {
    return (
      <>
        <TableContainer component={Paper}>
          <Table aria-label="collapsible table" stickyHeader>
            <TableHead>
              <TableRowStyle>
                <TableHeader>
                  {productList.length > 0 ? (
                    <IconButton
                      aria-label="expand row"
                      size="small"
                      onClick={() => setOpen(!open)}
                    >
                      {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                    </IconButton>
                  ) : (
                    <></>
                  )}
                </TableHeader>
                <TableHeader>Order Number</TableHeader>
                <TableHeader>Driver</TableHeader>
                <TableHeader>Customer</TableHeader>
                <TableHeader className="last-tr">Dispatch</TableHeader>
              </TableRowStyle>
            </TableHead>
            <TableBody>
              <TableRowStyle sx={{ '& > *': { borderBottom: 'unset' } }}>
                <TableCellRow colSpan={4} align="center">
                  {'No orders found for the selected route and date.'}
                </TableCellRow>
              </TableRowStyle>
            </TableBody>
          </Table>
        </TableContainer>
      </>
    );
  }

  // sx={{ height: [ '725px', '790px', '720px', '935px', '495px'] }}
  return (
    <>
      <TableContainer component={Paper}>
        <Table aria-label="collapsible table" stickyHeader>
          <TableHead>
            <TableRowStyle>
              <TableHeader>
                {productList.length > 0 ? (
                  <IconButton
                    aria-label="expand row"
                    size="small"
                    onClick={() => setOpen(!open)}
                  >
                    {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                  </IconButton>
                ) : (
                  <></>
                )}
              </TableHeader>
              <TableHeader>Order Number</TableHeader>
              <TableHeader>Driver</TableHeader>
              <TableHeader>Customer</TableHeader>
              <TableHeader className="last-tr">Dispatch</TableHeader>
            </TableRowStyle>
          </TableHead>
          <TableBody>
            {isProductsLoading
              ? iterate5Times.map((item) => <RowSkeleton key={'sr' + item} />)
              : productList.map((row, index) => (
                  <Row
                    key={`${row.OrderNumber1}-${index}`}
                    row={row}
                    openOverride={open}
                    searchProducts={searchProducts}
                  />
                ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}

/** SAVE FOR LATER
 * 
 *  RETURNS 
 * 
 * {
        <Stack direction='row' justifyContent='end' mt={1}>
            <Button
                variant="contained"
                size='large'
                sx={{ width: '25%' }}
                disabled
            >Update</Button>
        </Stack> 
    }
 * 
 */
